module.exports = __webpack_public_path__ + "media/images/2dImage-41c1e32dd272be239e586ab4ce526d67.svg";